import { render, staticRenderFns } from "./C2cSale.vue?vue&type=template&id=3963b6e1&scoped=true&"
import script from "./C2cSale.vue?vue&type=script&lang=js&"
export * from "./C2cSale.vue?vue&type=script&lang=js&"
import style0 from "./C2cSale.vue?vue&type=style&index=0&id=3963b6e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963b6e1",
  null
  
)

export default component.exports